import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { FilterProvider } from "./context/FilterContext";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import { CartProvider } from "react-use-cart";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Layout from "./pages/Layout";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Articles from "./pages/Articles";
import ArticleDetail from "./pages/ArticleDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Quiz from "./pages/Quiz";
import { AuthProvider } from "./context/AuthContext";
import { ArticleProvider } from "./context/ArticleContext";
import { ProductsProvider } from "./context/ProductContext";
import { OrderProvider } from "./context/OrderContext";
import Orders from "./pages/Orders";
import ProtectedRoute from "./components/ProtectedRoute";
import ForgotPassword from "./pages/ForgotPassword";

function App() {
const storedUser = JSON.parse(localStorage.getItem("user"));
const userId = storedUser?.id || "guest";

  return (
    <Router>
      <AuthProvider>
      <CartProvider id={`suprskin_cart_${userId}`}>
        <ProductsProvider>
        <FilterProvider>
          <OrderProvider>
          <ArticleProvider>
        <div className="min-h-screen bg-[#ed5da] flex flex-col">
            <main className="flex-grow">
              <Routes>
                <Route element={<Layout />}>
  <Route path="/" element={<Home />} />
  <Route path="/products" element={<Products />} />
  <Route path="/products/:id" element={<ProductDetail />} />
  <Route path="/about" element={<About />} />
  <Route path="/contact" element={<Contact />} />
  <Route path="/articles" element={<Articles />} />
  <Route path="/articles/:id" element={<ArticleDetail />} />
  <Route path="/orders" element={<Orders />} />
  <Route path="/quiz" element={<Quiz />} />
  <Route
    path="/cart"
    element={
      <ProtectedRoute>
        <Cart />
      </ProtectedRoute>
    }
  />
  <Route
    path="/checkout"
    element={
      <ProtectedRoute>
        <Checkout />
      </ProtectedRoute>
    }
  />
</Route>

                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
              </Routes>
            </main>
          </div>
          </ArticleProvider>
          </OrderProvider>
        </FilterProvider>
        </ProductsProvider>
      </CartProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
